import React, { useEffect, useState } from "react";
import { Domain } from "Domain";

// @material-ui/core components
// core components
import DoctorsTable from "components/Table/DoctorsTable.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import CardFooter from "components/Card/CardFooter.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import axios from "axios";
import Danger from "components/Typography/Danger";
// import ImageUpload from "components/CustomUpload/ImageUpload.js";

// import AttachFile from "@material-ui/icons/AttachFile";
// import CustomFileInput from "components/CustomFileInput/CustomFileInput.js";
import EmptyTable from "components/EmptyTable";
import SingleSelect from "components/SingleSelect";
import LinearIndeterminate from "components/Loader/LinearLoader";
import LoadingOverlay from "react-loading-overlay";

import Dialog from "@mui/material/Dialog";

import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import MuiButton from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

import {
  ChartLineUp,
  DownloadSimple,
  PencilSimple,
  Plus,
  Stethoscope,
  UploadSimple,
  X,
} from "@phosphor-icons/react";
import Slide from "@mui/material/Slide";
import { Chip } from "@material-ui/core";
import { saveAs } from "file-saver";
import XlsxPopulate from "xlsx-populate";
import * as xlsx from "xlsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
// import { data } from "./data.json";

const modalityColors = {
  CT: { bg: "#e8f0fe", color: "#2f72f2" },
  MR: { bg: "#ecfdf3", color: "#16833a" },
  DX: { bg: "#fff7e6", color: "#a05a00" },
};

function DashboardStat({ label, value, caption, tone }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        minHeight: 108,
        borderRadius: "8px",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        background: tone || "#ffffff",
        boxShadow: "0 18px 40px rgba(15, 23, 42, 0.06)",
        transition: "transform 180ms ease, box-shadow 180ms ease",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0 22px 46px rgba(15, 23, 42, 0.09)",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "8px",
            background: "rgba(26, 115, 232, 0.12)",
            display: "grid",
            placeItems: "center",
            color: "#1a73e8",
          }}
        >
          <Stethoscope size={16} weight="duotone" />
        </Box>
        <Typography sx={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>
          {label}
        </Typography>
      </Box>
      <Typography
        sx={{ mt: 1.2, color: "#0f172a", fontSize: 28, fontWeight: 800 }}
      >
        {value}
      </Typography>
      <Typography sx={{ color: "#94a3b8", fontSize: 12 }}>{caption}</Typography>
    </Paper>
  );
}

function DashboardPulse({ total, label }) {
  const bars = [42, 58, 48, 76, 64, 88, 70];
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "8px",
        border: "1px solid #e8eef7",
        background: "#ffffff",
        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.06)",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
        <Box>
          <Typography sx={{ color: "#162033", fontSize: 16, fontWeight: 900 }}>
            Registry activity
          </Typography>
          <Typography sx={{ color: "#94a3b8", fontSize: 12 }}>
            {label} profile momentum
          </Typography>
        </Box>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: "8px",
            display: "grid",
            placeItems: "center",
            color: "#2f72f2",
            background: "#e8f0fe",
          }}
        >
          <ChartLineUp size={18} weight="duotone" />
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "end", gap: 0.8, height: 92 }}>
        {bars.map((height, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              height: `${height}%`,
              borderRadius: "8px 8px 0 0",
              background: index === 5 ? "#2f72f2" : "#8fc1ff",
              animation: "thsBarRise 700ms ease both",
              animationDelay: `${index * 70}ms`,
            }}
          />
        ))}
      </Box>
      <Typography sx={{ mt: 1.4, color: "#64748b", fontSize: 12 }}>
        {total} active records tracked in the billing registry.
      </Typography>
    </Paper>
  );
}

function BodyPartsPricingTable({ rows, onEdit, onModalityFilter }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const paginatedRows = React.useMemo(() => {
    const start = page * rowsPerPage;
    return rows.slice(start, start + rowsPerPage);
  }, [rows, page, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [rows]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "8px",
        border: "1px solid #e8eef7",
        overflow: "hidden",
        boxShadow: "0 18px 40px rgba(15, 23, 42, 0.06)",
      }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {["Body part", "Modality", "Price", "Status", ""].map((head) => (
                <TableCell
                  key={head}
                  sx={{
                    borderBottom: "1px solid #e8eef7",
                    color: "#64748b",
                    fontSize: 12,
                    fontWeight: 800,
                    background: "#f8fbff",
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 5, border: 0 }}>
                  <Typography sx={{ color: "#94a3b8", fontSize: 14 }}>
                    No body-part pricing configured
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              paginatedRows.map((row) => {
                const tone = modalityColors[row.Modality] || modalityColors.CT;
                return (
                  <TableRow key={row.Id} hover>
                    <TableCell sx={{ borderBottom: "1px solid #eef3f9" }}>
                      <Typography
                        sx={{ color: "#0f172a", fontSize: 14, fontWeight: 700 }}
                      >
                        {row.BodyPart}
                      </Typography>
                      <Typography sx={{ color: "#94a3b8", fontSize: 12 }}>
                        ID #{row.Id}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #eef3f9" }}>
                      <Chip
                        size="small"
                        label={row.Modality}
                        onClick={() => onModalityFilter(row.Modality)}
                        style={{
                          background: tone.bg,
                          color: tone.color,
                          fontWeight: 700,
                          borderRadius: 8,
                          cursor: "pointer",
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #eef3f9" }}>
                      <Typography
                        sx={{ color: "#0f172a", fontSize: 14, fontWeight: 800 }}
                      >
                        Rs. {row.Price}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "1px solid #eef3f9" }}>
                      <Chip
                        size="small"
                        label={row.Status || "Active"}
                        style={{
                          background: "#ecfdf3",
                          color: "#16833a",
                          fontWeight: 700,
                          borderRadius: 8,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ borderBottom: "1px solid #eef3f9" }}
                    >
                      <Tooltip title="Edit pricing">
                        <IconButton
                          size="small"
                          onClick={() => onEdit(row.Id)}
                          sx={{
                            color: "#1a73e8",
                            background: "#e8f0fe",
                            borderRadius: "8px",
                            "&:hover": { background: "#d8e7ff" },
                          }}
                        >
                          <PencilSimple size={18} weight="duotone" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows.length > 0 && (
        <TablePagination
          component="div"
          count={rows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
          sx={{ borderTop: "1px solid #e8eef7" }}
        />
      )}
    </Paper>
  );
}

export default function DoctorsList() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const [saved, setSaved] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [edit, setEdit] = useState([]);
  const [Doctors, setDoctors] = useState([]);
  // const [files, setFiles] = useState(null);
  const [BodyPartvalidated, setBodyPartValidated] = useState(true);
  const [validated, setValidated] = useState(true);
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(false);
  const [AddStaff, setAddStaff] = useState(false);
  const [AddBodyPart, setAddBodyPart] = useState(false);
  const [Open, setOpen] = useState(false);
  const [BodyParts, setBodyParts] = useState([]);
  const [DoctorDetails, setDoctorDetails] = useState([]);
  const [BodyPartsLoading, setBodyPartsLoading] = useState(false);
  const [EditLoading, setEditLoading] = useState(false);
  const [openDiloge, setOpenDiloge] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);

  //Saved Notification trigger

  const showSavedNotification = () => {
    if (!saved) {
      setSaved(true);
      setTimeout(function () {
        setSaved(false);
      }, 3000);
    }
  };
  //Deleted Notification Trigger
  const showDeletedNotification = () => {
    if (!deleted) {
      setDeleted(true);
      setTimeout(function () {
        setDeleted(false);
      }, 3000);
    }
  };
  //Form Data
  const [data, setData] = React.useState({
    Id: 0,
    FullName: "",
    Email: "",
    Pan: "",
  });
  const [bodypartData, setBodypartData] = React.useState({
    Id: 0,
    BodyPart: "",
    Price: "",
    Modality: "",
    ModalityId: "",
    DoctorId: "",
    Status: "Active",
  });
  useEffect(() => {
    if (!AddBodyPart) {
      setBodypartData({
        Id: 0,
        BodyPart: "",
        Price: "",
        Modality: "",
        ModalityId: "",
        DoctorId: "",
        Status: "Active",
      });
    }
  }, [AddBodyPart]);
  //Function to handle Data input
  function HandleData(e) {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    ////console.log(newData);
  }
  function HandleBodyData(e) {
    const newData = { ...bodypartData };
    newData[e.target.id] = e.target.value;
    setBodypartData(newData);
    ////console.log(newData);
  }
  function HandleClear() {
    setData({
      Id: 0,
      FullName: "",
      Email: "",
      Pan: "",
    });
  }
  //Function for Validating fields
  function ValidateFields() {
    if (data.FullName == "") {
      return false;
    } else if (data.Email == "") {
      return false;
    } else if (data.Pan == "") {
      return false;
    } else return true;
  }

  //To get Developer list from database
  useEffect(() => {
    let formData = new FormData();
    formData.append("Status", "Active");
    axios({
      method: "post",
      url: Domain + "/GetAllDoctors.php",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function (response) {
        //handle success
        //console.log("Doctors Response:", response.data);
        if (response.data.TotalCount != 0) {
          setDoctors(response.data.data);
          //console.log("setDoctors ", response.data.data);
          setLoading(false);
        } else {
          setEmpty(true);
        }
      })
      .catch(function (response) {
        //handle error
        showDeletedNotification();
        console.log(response);
      });
  }, [refresh]);
  const DoctorsData = Doctors.map((d) => ({
    Id: d.Id,
    Name: d.Name,
    Email: d.Email || "",
    Pan: d.Pan || "",
  }));
  //Function for Validating fields
  function ValidateBodyPartFields() {
    if (bodypartData.BodyPart == "") {
      return false;
    } else if (!ModalityValues.Label && !ModalityValues.label) {
      return false;
    } else if (bodypartData.Price == "") {
      return false;
    } else return true;
  }
  function HandleBoyPartSave() {
    if (ValidateBodyPartFields()) {
      setBodyPartValidated(true);
      let formData = new FormData();
      formData.append("Id", bodypartData.Id);
      formData.append("BodyPart", bodypartData.BodyPart);
      formData.append("Price", bodypartData.Price);
      formData.append("Modality", ModalityValues.Label);
      formData.append("ModalityId", ModalityValues.Id);
      formData.append("DoctorId", edit);
      formData.append(
        "StringId",
        bodypartData.BodyPart.replace(/ /g, "")
          .replace(/[^a-zA-Z0-9 ]/g, "")
          .toLowerCase()
      );
      axios({
        method: "post",
        url: Domain + "/saveBodyPartsDoctor.php",
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then(function (response) {
          //handle success
          console.log(response);
          if (response.data.success) {
            setBodypartData({
              Id: 0,
              BodyPart: "",
              Price: "",
              Modality: "",
              ModalityId: "",
              DoctorId: "",
              Status: "Active",
            });
            setAddStaff(false);
            HandleClose();
            setEmpty(false);
            showSavedNotification();
            setBodyPartEdit("");
            //console.log("saved");
          } else {
            showDeletedNotification;
            //console.log("failed");
          }
        })
        .catch(function (response) {
          //handle error
          setDeleted(true);
          console.log(response);
        });
    } else {
      setBodyPartValidated(false);
    }
  }
  //Function to save Data
  function HandleSave() {
    if (ValidateFields()) {
      setValidated(true);
      let formData = new FormData();
      formData.append("Id", data.Id);
      formData.append("FullName", data.FullName);
      formData.append("Email", data.Email);
      formData.append("Pan", data.Pan);
      formData.append(
        "StringId",
        data.FullName.replace(/ /g, "")
          .replace(/[^a-zA-Z0-9 ]/g, "")
          .toLowerCase()
      );

      axios({
        method: "post",
        url: Domain + "/SaveDoctor.php",
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then(function (response) {
          //handle success
          console.log("Doctor saved:", response);
          if (response.data.success) {
            setData({
              Id: 0,
              FullName: "",
              Email: "",
              Pan: "",
            });
            //call the api for insert dummy price dumb
            /////////////////////////////////////////

            let formData = new FormData();
            formData.append("Id", response.data.data.Id);
            axios({
              method: "post",
              url: Domain + "/SaveDocDefaultData.php",
              data: formData,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            })
              .then(function (response) {
                //handle success
                console.log(" defualt BodyParts Added", response);
                if (response.data.success) {
                  setAddStaff(false);
                  setEmpty(false);
                  showSavedNotification();
                  //console.log("saved");
                  if (refresh) setRefresh(false);
                  else setRefresh(true);
                } else {
                  showDeletedNotification;
                  //console.log("failed");
                }
              })
              .catch(function (response) {
                //handle error
                setDeleted(true);
                console.log(response);
              });

            /////////////////////////////////////////

            //console.log("saved");
          } else {
            showDeletedNotification;
            //console.log("failed");
          }
        })
        .catch(function (response) {
          //handle error
          setDeleted(true);
          console.log(response);
        });
    } else {
      setValidated(false);
    }
  }
  useEffect(() => {
    //console.log("clicked: ", edit);
    if (edit != "") {
      setOpen(true);
      //Get Data correcsponding to the id
      let formData = new FormData();

      formData.append("Id", edit);

      axios({
        method: "post",
        url: Domain + "/GetDoctorById.php",
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then(function (response) {
          //handle success
          //console.log("getDoctorById:", response);
          if (response.data.success) {
            setDoctorDetails(response.data.data[0]);
            //if Doctor details got from db, then get the body parts from db
            let formData = new FormData();
            formData.append("Id", edit);
            axios({
              method: "post",
              url: Domain + "/GetBodypartsByDoctorId.php",
              data: formData,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            })
              .then(function (response) {
                //handle success
                console.log("GetBodypartsByDoctorId:", response);
                if (response.data.success) {
                  if (response.data.TotalCount > 0)
                    setBodyParts(response.data.data);
                }
              })
              .catch(function (response) {
                //handle error
                console.log(response);
              });
          }
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    }
  }, [edit, openDiloge]);
  function HandleBack() {
    setOpen(false);
    setEdit("");
    setDoctorDetails([]);
    setBodyParts([]);
  }
  const bodyPartSelect = BodyParts.map((d) => ({
    value: d.Id,
    label: d.BodyPart,
  }));
  const ModalityList = [
    { value: 1, label: "CT" },
    { value: 2, label: "MR" },
    { value: 3, label: "DX" },
  ];
  const [ModalityValues, SetModalityValues] = React.useState({
    Id: null,
    label: "",
  });
  function HandleModalityFilter(Modality, Id) {
    let formData = new FormData();

    formData.append("Id", Id);
    formData.append("Modality", Modality);
    axios({
      method: "post",
      url: Domain + "/GetBodypartsByDocIdAndModality.php",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function (response) {
        //handle success
        console.log("GetBodypartsByDocIdAndModality", response.data);
        if (response.data.TotalCount != 0) {
          if (response.data.success) {
            setBodyParts(response.data.data);
          }
        }
      })
      .catch(function (response) {
        //handle error
        showDeletedNotification();
        console.log(response);
      });
  }
  //console.log("ModalityValues:", ModalityValues);
  const [BodyPartEdit, setBodyPartEdit] = useState("");
  const [selected, setSelected] = useState("");

  useEffect(() => {
    //console.log("Bodypartdata:::::::::::::::::::::::", bodypartData);
  }, [bodypartData]);
  useEffect(() => {
    console.log("BodyPartEdit::::::", BodyPartEdit);
    //console.log("BodyParts============", BodyParts);
    setBodyPartsLoading(true);
    if (BodyParts != "") {
      setBodyPartsLoading(false);

      if (BodyPartEdit != "") {
        setEditLoading(true);

        ///////////////////////////////////////
        let formData = new FormData();
        formData.append("Id", BodyPartEdit);
        axios({
          method: "post",
          url: Domain + "/GetBodypartsByIdDoc.php",
          data: formData,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        })
          .then(function (response) {
            //handle success
            //console.log("GetBodypartsByIdDoc:", response);
            if (response.data.success) {
              if (response.data.TotalCount > 0) {
                setBodypartData(response.data.data[0]);
                setEditLoading(false);
                setOpenDiloge(true);
                setSelected({
                  value: response.data.data[0].ModalityId,
                  label: response.data.data[0].Modality,
                });
                SetModalityValues({
                  Id: response.data.data[0].ModalityId,
                  Label: response.data.data[0].Modality,
                });
              }
            } else {
              setEditLoading(false);
            }
          })
          .catch(function (response) {
            //handle error
            console.log(response);
          });
      } else {
        setAddBodyPart(false);
      }
    } else {
      //console.log("BodyPart Error");
    }
  }, [BodyPartEdit, BodyParts]);
  //console.log("BodyPartEdit+++++++++++++++++", BodyPartEdit);
  // //console.log("bodypartData:", bodypartData);
  // //console.log("BodyPartEdit:", BodyPartEdit);
  // //console.log("BodyParts[BodyPartEdit]:", BodyParts[BodyPartEdit - 1]);
  function HandleClose() {
    setAddBodyPart(false);
    setBodyPartEdit("");
    setBodypartData({
      Id: 0,
      BodyPart: "",
      Price: "",
      Modality: "",
      ModalityId: "",
      DoctorId: "",
      Status: "Active",
    });
    setOpenDiloge(false);
  }
  const [DocData, setDocData] = useState({
    DocName: "",
    Email: "",
    Pan: "",
  });
  const [EditClicked, setEditClicked] = useState(false);
  function HandleEditClicked() {
    if (EditClicked) {
      setEditClicked(false);
      setDocData("");
    } else {
      setDocData({
        DocName: DoctorDetails.Name,
        Email: DoctorDetails.Email || "",
        Pan: DoctorDetails.Pan || "",
      });
      setEditClicked(true);
    }
  }
  function HandleDocData(e) {
    const newData = { ...DocData };
    newData[e.target.id] = e.target.value;
    setDocData(newData);
    //console.log(newData);
  }
  function HandleDocSave() {
    let formData = new FormData();
    formData.append("Id", edit);
    formData.append("FullName", DocData.DocName);
    formData.append("Email", DocData.Email);
    formData.append(
      "StringId",
      DocData.DocName.replace(/ /g, "")
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .toLowerCase()
    );
    formData.append("Pan", DocData.Pan);
    axios({
      method: "post",
      url: Domain + "/SaveDoctor.php",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function (response) {
        //handle success
        console.log("Doctor Updated:", response);
        if (response.data.success) {
          showSavedNotification();
        } else {
          showDeletedNotification();
        }
      })
      .catch(function (response) {
        //handle error
        showDeletedNotification();
        console.log(response);
      });
  }
  const [SelectedBodyPart, SetSelectedBodyPart] = useState("");
  console.log("SelectedBodyPart:", SelectedBodyPart);
  useEffect(() => {
    setBodyPartEdit(SelectedBodyPart.Id);
  }, [SelectedBodyPart.Id]);
  function HandleClearFliter() {
    let formData = new FormData();
    formData.append("Id", edit);
    axios({
      method: "post",
      url: Domain + "/GetBodypartsByDoctorId.php",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function (response) {
        //handle success
        //console.log("GetBodypartsByDoctorId:", response);
        if (response.data.success) {
          if (response.data.TotalCount > 0) setBodyParts(response.data.data);
        }
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  }
  ///Upload excel
  const [jsontoInsert, setJsontoInsert] = useState([]);
  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        setJsontoInsert(json);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };
  function getSheetData(data, header) {
    var fields = Object.keys(data[0]);
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : "";
      });
    });
    sheetData.unshift(header);
    return sheetData;
  }
  async function saveAsExcelClient() {
    if (BodyParts) {
      let header = [
        "Id",
        "BodyPart",
        "Price",
        "Modality",
        "ModalityId",
        "Status",
        "DoctorId",
      ];

      XlsxPopulate.fromBlankAsync().then(async (workbook) => {
        const sheet1 = workbook.sheet(0);
        const sheetData = getSheetData(BodyParts, header);
        const totalColumns = sheetData[0].length;

        sheet1.cell("A1").value(sheetData);
        sheet1.column("A").width(10);
        sheet1.column("B").width(25);
        sheet1.column("C").width(25);
        sheet1.column("D").width(25);
        sheet1.column("E").width(25);
        sheet1.column("F").width(25);
        sheet1.column("G").width(25);
        const range = sheet1.usedRange();
        const endColumn = String.fromCharCode(64 + totalColumns);
        sheet1.row(1).style("bold", true);
        sheet1.range("A1:" + endColumn + "1").style("fill", "d3d3d3");
        range.style("border", false);
        return workbook.outputAsync().then((res) => {
          saveAs(res, "bodyparts_doctor.xlsx");
        });
      });
    }
  }
  function HandleUploadBulkData() {
    console.log("clicked", jsontoInsert);
    if (jsontoInsert != []) {
      let formData = new FormData();
      formData.append("Id", edit);
      axios({
        method: "post",
        url: Domain + "/DeleteBodyPartsByDoctorId.php",
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then(function (response) {
          //handle success
          console.log("DeleteBodyParts Response:", response);
          if (response.data.success) {
            axios({
              method: "post",
              url: Domain + "/SaveDocBodyPartsFromExcel.php",
              data: JSON.stringify(jsontoInsert),
              config: { headers: { "Content-Type": "multipart/form-data" } },
            })
              .then(function (response) {
                //handle success
                console.log("ExcelUpload Response:", response);
                if (response.data.TotalCount != 0) {
                  //success
                  alert("Upload Complete");
                }
              })
              .catch(function (response) {
                //handle error
                console.log(response);
              });
          }
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } else {
      alert("Select excel file to upload!");
    }
  }
  const configuredBodyParts = BodyParts.length;
  const uniqueModalities = new Set(
    BodyParts.map((item) => item.Modality).filter(Boolean)
  ).size;

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 110px)",
        mx: { xs: -2, md: -3 },
        my: { xs: -1, md: -2 },
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 3 },
        background:
          "linear-gradient(180deg, #f7fbff 0%, #eef6ff 42%, #f8fbff 100%)",
      }}
    >
      <Snackbar
        place="bc"
        color="success"
        icon={AddAlert}
        message="Doctor Saved!"
        open={saved}
        closeNotification={() => setSaved(false)}
        close
      />
      <Snackbar
        place="bc"
        color="danger"
        icon={AddAlert}
        message="Failed! Try again"
        open={deleted}
        closeNotification={() => setDeleted(false)}
        close
      />
      <Dialog
        open={Open}
        onClose={HandleBack}
        fullWidth
        maxWidth="lg"
        scroll="paper"
        BackdropProps={{
          sx: {
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(15, 23, 42, 0.55)",
          },
        }}
        PaperProps={{ sx: { borderRadius: "8px" } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            p: { xs: 2, md: 3 },
            background: "linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%)",
            borderBottom: "1px solid #e5eef9",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              sx={{
                width: 46,
                height: 46,
                bgcolor: "#2f72f2",
                fontWeight: 800,
              }}
            >
              {(DoctorDetails.Name || "D").charAt(0).toUpperCase()}
            </Avatar>
            <Box>
              <Typography
                sx={{ fontSize: 21, fontWeight: 800, color: "#0f172a" }}
              >
                {DoctorDetails.Name || "Doctor profile"}
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#64748b", mt: 0.25 }}>
                {DoctorDetails.Email || "No email added"} |{" "}
                {configuredBodyParts} configured body parts
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <MuiButton
              variant="outlined"
              startIcon={<PencilSimple size={17} weight="duotone" />}
              onClick={HandleEditClicked}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Edit
            </MuiButton>
            <MuiButton
              variant="contained"
              startIcon={<Plus size={17} weight="bold" />}
              onClick={() => setAddBodyPart(true)}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 700,
                boxShadow: "none",
              }}
            >
              Add price
            </MuiButton>
            <IconButton onClick={HandleBack} sx={{ ml: 1 }}>
              <X size={22} weight="bold" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ p: { xs: 2, md: 3 }, background: "#fbfdff" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
              gap: 2,
              mb: 2.5,
            }}
          >
            <DashboardStat
              label="Body Parts"
              value={configuredBodyParts}
              caption="Configured for this doctor"
            />
            <DashboardStat
              label="Modalities"
              value={uniqueModalities || 0}
              caption="CT, MR and DX coverage"
            />
            <DashboardStat
              label="Status"
              value="Active"
              caption="Available for billing"
            />
          </Box>
          {EditClicked ? (
            <Paper
              elevation={0}
              sx={{
                p: 2.5,
                mb: 2.5,
                borderRadius: "8px",
                border: "1px solid #e8eef7",
              }}
            >
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    onChange={(e) => HandleDocData(e)}
                    value={DocData.DocName}
                    labelText="Doctor's Name"
                    id="DocName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    onChange={(e) => HandleDocData(e)}
                    value={DocData.Email}
                    labelText="Email"
                    id="Email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    onChange={(e) => HandleDocData(e)}
                    value={DocData.Pan}
                    labelText="Pan Number"
                    id="Pan"
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <Button round onClick={HandleEditClicked} color="primary">
                    Cancel
                  </Button>
                  <Button color="primary" round onClick={HandleDocSave}>
                    Save
                  </Button>
                </GridItem>
              </GridContainer>
            </Paper>
          ) : (
            <>
              {AddBodyPart ? (
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    mb: 2.5,
                    borderRadius: "8px",
                    border: "1px solid #e8eef7",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#0f172a",
                      fontSize: 16,
                      fontWeight: 800,
                      mb: 1,
                    }}
                  >
                    Add body-part pricing
                  </Typography>
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          onChange={(e) => HandleBodyData(e)}
                          value={bodypartData.BodyPart}
                          labelText="Body Part"
                          id="BodyPart"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          onChange={(e) => HandleBodyData(e)}
                          value={bodypartData.Price}
                          labelText="Price"
                          id="Price"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <SingleSelect
                          noOptionsMessage="No modalities"
                          placeholder="Select Modality"
                          Options={ModalityList}
                          setValue={SetModalityValues}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      {BodyPartvalidated ? (
                        <></>
                      ) : (
                        <Danger>Input all the details</Danger>
                      )}
                    </GridContainer>
                  </CardBody>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      pt: 1,
                    }}
                  >
                    <Button onClick={HandleClose} color="primary">
                      Cancel
                    </Button>

                    <Button onClick={HandleBoyPartSave} color="primary">
                      Save
                    </Button>
                  </Box>
                </Paper>
              ) : (
                <></>
              )}
            </>
          )}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 2.5,
              borderRadius: "8px",
              border: "1px solid #e8eef7",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.5,
            }}
          >
            <Box>
              <Typography
                sx={{ color: "#0f172a", fontSize: 14, fontWeight: 800 }}
              >
                Tariff data
              </Typography>
              <Typography sx={{ color: "#94a3b8", fontSize: 12 }}>
                Import or export doctor-specific body-part prices
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <form>
                <input
                  type="file"
                  name="upload"
                  id="upload"
                  onChange={readUploadFile}
                  style={{ display: "none" }}
                />
                <MuiButton
                  component="label"
                  htmlFor="upload"
                  variant="outlined"
                  startIcon={<UploadSimple size={18} weight="duotone" />}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 700,
                  }}
                >
                  Choose file
                </MuiButton>
              </form>
              <MuiButton
                onClick={saveAsExcelClient}
                variant="outlined"
                startIcon={<DownloadSimple size={18} weight="duotone" />}
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 700,
                }}
              >
                Export
              </MuiButton>
              <MuiButton
                onClick={HandleUploadBulkData}
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 700,
                  boxShadow: "none",
                }}
              >
                Upload
              </MuiButton>
            </Box>
          </Paper>
          {BodyPartsLoading ? (
            <>
              <LinearIndeterminate />
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "180px 1fr" },
                  gap: 1.5,
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <MuiButton
                  onClick={HandleClearFliter}
                  variant="outlined"
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 700,
                  }}
                >
                  Clear filter
                </MuiButton>
                <SingleSelect
                  noOptionsMessage="No bodyParts"
                  placeholder="Search body part"
                  Options={bodyPartSelect}
                  setValue={SetSelectedBodyPart}
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </Box>
              <LoadingOverlay active={EditLoading} spinner text="Please Wait..">
                <BodyPartsPricingTable
                  rows={BodyParts}
                  onEdit={setBodyPartEdit}
                  onModalityFilter={(modality) =>
                    HandleModalityFilter(modality, edit)
                  }
                />
              </LoadingOverlay>
              <Dialog
                open={openDiloge}
                onClose={HandleClose}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { borderRadius: "8px" } }}
              >
                <Box
                  sx={{
                    p: 2.5,
                    borderBottom: "1px solid #e8eef7",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{ color: "#0f172a", fontSize: 18, fontWeight: 800 }}
                  >
                    Edit body-part pricing
                  </Typography>
                  <IconButton onClick={HandleClose}>
                    <X size={22} weight="bold" />
                  </IconButton>
                </Box>
                <Box sx={{ p: 2.5 }}>
                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          onChange={(e) => HandleBodyData(e)}
                          value={bodypartData.BodyPart}
                          labelText="Body Part"
                          id="BodyPart"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <CustomInput
                          onChange={(e) => HandleBodyData(e)}
                          value={bodypartData.Price}
                          labelText="Price"
                          id="Price"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <SingleSelect
                          selectedVal={selected}
                          noOptionsMessage="No modalities"
                          placeholder="Select Modality"
                          Options={ModalityList}
                          setValue={SetModalityValues}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>
                      {BodyPartvalidated ? (
                        <></>
                      ) : (
                        <Danger>Input all the details</Danger>
                      )}
                    </GridContainer>
                  </CardBody>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      pt: 1,
                    }}
                  >
                    <Button onClick={HandleClose} color="primary">
                      Cancel
                    </Button>

                    <Button onClick={HandleBoyPartSave} color="primary">
                      Save
                    </Button>
                  </Box>
                </Box>
              </Dialog>
            </>
          )}
        </Box>
      </Dialog>

      <Dialog
        open={AddStaff}
        onClose={() => setAddStaff(false)}
        fullWidth
        maxWidth="sm"
        BackdropProps={{
          sx: {
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(15, 23, 42, 0.55)",
          },
        }}
        PaperProps={{ sx: { borderRadius: "8px" } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2.5,
            borderBottom: "1px solid #eef1f5",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: 700, color: "#1e293b" }}
            >
              Add Doctor
            </Typography>
            <Typography sx={{ fontSize: "13px", color: "#94a3b8", mt: 0.25 }}>
              Enter the doctor&apos;s details
            </Typography>
          </Box>
          <IconButton onClick={() => setAddStaff(false)}>
            <X size={22} weight="bold" />
          </IconButton>
        </Box>
        <form>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  onChange={(e) => HandleData(e)}
                  value={data.FullName}
                  labelText="Name"
                  id="FullName"
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  onChange={(e) => HandleData(e)}
                  value={data.Email}
                  labelText="Email"
                  id="Email"
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  onChange={(e) => HandleData(e)}
                  value={data.Pan}
                  labelText="PAN Card Number"
                  id="Pan"
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                {" "}
                {validated ? (
                  <></>
                ) : (
                  <Danger>
                    Please enter doctor name, email and PAN to save
                  </Danger>
                )}
              </GridItem>
            </GridContainer>
          </CardBody>
          <CardFooter>
            <Button onClick={() => setAddStaff(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={HandleClear} color="primary">
              Clear
            </Button>
            <Button onClick={HandleSave} color="primary">
              Save
            </Button>
          </CardFooter>
        </form>
      </Dialog>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            mb: 3,
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: 28, fontWeight: 900, color: "#162033" }}
            >
              Doctor Registry
            </Typography>
            <Typography sx={{ fontSize: 14, color: "#64748b", mt: 0.6 }}>
              Manage doctor master data and tariff configuration
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <MuiButton
              variant="contained"
              startIcon={<Plus size={17} weight="bold" />}
              onClick={() => setAddStaff(true)}
              sx={{
                background: "#2f72f2",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 900,
                boxShadow: "0 8px 18px rgba(47,114,242,0.22)",
                px: 2,
                py: 1,
                "&:hover": { background: "#1d5fce" },
              }}
            >
              Add Doctor
            </MuiButton>
          </Box>
        </Box>
        <Box sx={{ mb: 2 }}>
          <DashboardPulse total={Doctors.length} label="Doctor" />
        </Box>
        <Paper
          elevation={0}
          sx={{
            borderRadius: "8px",
            p: 1.5,
            border: "1px solid #e8eef7",
            background: "#ffffff",
            boxShadow: "0 18px 42px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Box
            sx={{
              px: 1.5,
              py: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box>
              <Typography
                sx={{ fontSize: 20, color: "#0f172a", fontWeight: 900 }}
              >
                Doctor registry
              </Typography>
              <Typography sx={{ fontSize: 15, color: "#94a3b8", mt: 0.4 }}>
                Select a doctor to edit profile and body-part prices
              </Typography>
            </Box>
            <Chip
              label="Production"
              size="small"
              style={{
                background: "#ecfdf3",
                color: "#16833a",
                fontWeight: 700,
              }}
            />
          </Box>
          <Divider sx={{ mb: 1.5 }} />
          {empty ? (
            <EmptyTable />
          ) : (
            <DoctorsTable
              data={DoctorsData}
              loading={loading}
              onEdit={setEdit}
            />
          )}
        </Paper>
      </Box>
    </Box>
  );
}
